import React from "react";
import {
  Box,
  Center,
  Text,
  Image,
  Button,
  Heading,
  ChakraProvider,
  useBreakpointValue,
} from "@chakra-ui/react";

const TermeniConditiiCardCadou = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      {/* <Center>Aici va fi conținutul.</Center> */}
      <br />
      <br />
      <Center>Termeni și condiții Card Cadou</Center>
      <br />
      <br />
      <br />
      <br />
      <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br /> <br />{" "}
      <br /> <br /> <br /> <br /> <br />
    </>
  );
};

export default TermeniConditiiCardCadou;
